import BossModel from "@/models/BossModel";
import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";
import PublicImage from "@/models/PublicImage/PublicImage";
import WebsiteProductTagType from "@/models/WebsiteProduct/Tag/Type/Type";
import WebsiteProductTagTypeWebsiteCategory from "@/models/WebsiteProduct/Tag/Type/Category/Category";

export default class WebsiteCategory extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = "website-category";

    /**
     *
     * @type {string}
     */
    static entity = "websiteCategories";

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            url: this.attr(null),
            is_active: this.boolean(true),
            media_library_item_id: this.number(null).nullable(),
            header_public_image_id: this.number(null).nullable(),
            sort_order: this.number(null).nullable(),
            headerPublicImage: this.belongsTo(PublicImage, "header_public_image_id"),
            mediaLibraryItem: this.belongsTo(
                MediaLibraryItem,
                "media_library_item_id",
            ),
            tagTypes: this.belongsToMany(
                WebsiteProductTagType,
                WebsiteProductTagTypeWebsiteCategory,
                "website_category_id",
                "website_product_tag_type_id",
            ),
        };
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get()
            .then((data) => {
                let instances = [];
                for (let key in data) {
                    instances.push(new WebsiteCategory(data[key]));
                }
                return instances;
            });
    }

    /**
     *
     * @param ids
     * @returns {*}
     */
    static byIds(ids) {
        return this.all().filter((item) => ids.includes(item.id));
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    WebsiteUrl() {
        return window.config.WEBSITE_URL + "/" + this.url;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    MediaLibraryItem() {
        return this.getRelated("mediaLibraryItem");
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).get(true);
    }
}
